import { useEffect, useState } from 'react';

import { cx } from '@emotion/css';
import { Row } from 'antd';
import { isUndefined } from 'lodash';
import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';
import { Heading, Spacing } from 'src/styles';
import { getAccountHolderSubheader } from 'src/utils';

import { DisclosuresForm } from './DisclosuresForm';
import { DisclosuresView } from './DisclosuresView';

export const JointAccountHolderDisclosureSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isDisclosureAlreadySaved = () =>
    !isUndefined(account?.secondaryAccountHolder?.disclosure?.statementDelivery?.value);

  useEffect(() => {
    if (isDisclosureAlreadySaved()) {
      setIsEditable(true);
    }
  }, [account?.secondaryAccountHolder?.disclosure]);

  return (
    <>
      <Row className={cx(Heading.title, Spacing.my32)}>
        {getAccountHolderSubheader({ type: account?.type, authorizedSigner: account?.type.isEntity ? 2 : undefined })}
      </Row>
      <MFormSection
        title='Disclosures'
        onEdit={onEdit}
        isEditable={isEditable}
        isEditMode={isEditMode}
        testId={'joint-disclosures'}>
        {isDisclosureAlreadySaved() && !isEditMode ? (
          <DisclosuresView accountHolder={account?.secondaryAccountHolder} isPrimary={false} />
        ) : (
          <DisclosuresForm
            accountUuid={account?.id}
            accountHolder={account?.secondaryAccountHolder}
            isPrimary={false}
            onCancel={onCancel}
            testId={'joint'}
          />
        )}
      </MFormSection>
    </>
  );
};
